import { render, staticRenderFns } from "./EstatusIncidencias.vue?vue&type=template&id=664ab478&scoped=true"
import script from "./EstatusIncidencias.vue?vue&type=script&lang=js"
export * from "./EstatusIncidencias.vue?vue&type=script&lang=js"
import style0 from "./EstatusIncidencias.vue?vue&type=style&index=0&id=664ab478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ab478",
  null
  
)

export default component.exports